// stylelint-disable property-no-vendor-prefix
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { BREAKPOINTS, COLORS, FONT_SIZE, GLOBAL } from '../../constants';

import {
  StyledExpandButton,
  StyledFormControl,
  StyledInputLabel,
  StyledToggleButton,
  StyledToggleButtonGroup,
} from './styles';

const Select = styled.select`
  appearance: none;
  background-color: white;
  color: black;
  cursor: pointer;
  border: 2px solid ${COLORS.BRAND_BLUE_NINE};
  border-radius: 0;
  font-family: ${GLOBAL.BRAND_FONT_FAMILY};
  font-size: ${FONT_SIZE.MEDIUM};
  line-height: 16px;
  outline: none;
  padding: 16px;
  padding-right: 2rem;
  -webkit-appearance: none;
  width: 100%;

  &:focus {
    outline: 2px solid ${COLORS.BRAND_BLUE_NINE};
    outline-offset: 2px;
  }

  /* option { */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* max-width: 100px; */
  /* } */
`;

const StyledSelectContainer = styled.div`
  position: relative;
  width: 100%;

  @media (min-width: ${BREAKPOINTS.MD}px) {
    width: 200px;
  }
`;

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'label' implicitly has an 'any' type.
const VariantFilter = ({ label, options, selectedOption = {}, onChange, isFullWidth = false }) => {
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'id' implicitly has an 'any' type.
  const mappedOptions = options.map(({ id, value }) => ({ value: id, label: value }));
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'option' implicitly has an 'any' type.
  const selectedValue = mappedOptions.find((option) => option.label === selectedOption.value)?.value;

  const selectID = `react-select-container-${label}`;

  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'event' implicitly has an 'any' type.
  const handleChange = (event) => {
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'option' implicitly has an 'any' type.
    const updatedOption = mappedOptions.find((option) => option.value === event.target.value);
    onChange(updatedOption);
  };

  return (
    <StyledFormControl fullWidth={isFullWidth}>
      <StyledInputLabel htmlFor={selectID} disableAnimation shrink={false}>
        {label}
      </StyledInputLabel>
      {label === 'Year' ? (
        <StyledSelectContainer>
          <Select
            name="variant"
            key={`select-${label}`}
            id={selectID}
            onChange={(event) => {
              // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'option' implicitly has an 'any' type.
              const updatedOption = mappedOptions.find((option) => option.value === event.target.value);

              onChange(updatedOption);
            }}
            value={selectedValue}
          >
            <option value="" disabled selected hidden>
              Select an option...
            </option>
            {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'optionLabel' implicitly has an 'any' type. */}
            {mappedOptions.map(({ label: optionLabel, value }) => (
              <option key={optionLabel} value={value}>
                {optionLabel}
              </option>
            ))}
          </Select>
          {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{}' is missing the following properties from type '{ className: any; onClick: any; }': className, onClick */}
          <StyledExpandButton />
        </StyledSelectContainer>
      ) : (
        <StyledToggleButtonGroup
          // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ children: any; name: any; "aria-label": any; color: "primary"; value: any; exclusive: true; onChange: (event: any) => void; }' is not assignable to type 'IntrinsicAttributes & ToggleButtonGroupProps & { theme?: Theme | undefined; }'.
          name={label}
          aria-label={label}
          color="primary"
          value={selectedValue}
          exclusive
          onChange={handleChange}
        >
          {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'option' implicitly has an 'any' type. */}
          {mappedOptions.map((option) => (
            <StyledToggleButton key={option.label} value={option.value} aria-label={option.label} disableRipple>
              {option.label}
            </StyledToggleButton>
          ))}
        </StyledToggleButtonGroup>
      )}
    </StyledFormControl>
  );
};

VariantFilter.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  selectedOption: PropTypes.shape({
    id: PropTypes.string,
    value: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  isFullWidth: PropTypes.bool,
};

export default VariantFilter;
